/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum exportFormatEnum {
    EXPERT = 'Expert',
    QUESTION = 'Question',
}